import { useState, useEffect } from 'react';

// WebView環境かどうかを判定するカスタムフック
export const useIsWebView = (): boolean => {
  const [isWebView, setIsWebView] = useState<boolean>(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    setIsWebView(/HomeKarteApp/i.test(userAgent));
  }, []);

  return isWebView;
};
